import jwt_decode from "jwt-decode";
import { useMemo } from "react";
import { usePaymentContext } from "../../../../contexts/payment-context";
import { FailureTypeValue } from "../../types";
import { useAppContext } from "@ftdr/blueprint-components-react";

type UseTokenSemanticValidation = { isError: boolean; message: string };

export const useTokenSemanticValidation = (
  token?: string
): UseTokenSemanticValidation => {
  const { onFailure } = usePaymentContext();
  const {
    appSettings: { localizedText },
  } = useAppContext();

  return useMemo(() => {
    try {
      jwt_decode(token || "");
      return { isError: false, message: "" };
    } catch (err) {
      const errorObject = {
        isError: true,
        message: localizedText(`TOKEN_ERROR`),
      };
      const errorResult = {
        type: FailureTypeValue.TOKEN_FAILURE,
        tokenError: {
          message: errorObject.message,
        },
      };
      onFailure(errorResult);
      return errorObject;
    }
  }, [token, localizedText, onFailure]);
};
